/* istanbul ignore file */
import _ from 'underscore';
import { navRefreshPageIds } from '@bingads-webui-react/with-site-map';

import { SitemapItem } from '../types';

const NavRefreshL1PinnedPreferenceKey = 'NavRefreshL1Pined';

const getDefaultPmaxPinItems = (permissions) => {
  const assetsManagementEntry = permissions.dynamic.AdsStudioMVP ? navRefreshPageIds.adStudio : navRefreshPageIds.assetLibrary;
  return [
    navRefreshPageIds.conversions,
    assetsManagementEntry,
    navRefreshPageIds.imports,
    navRefreshPageIds.reports,
    navRefreshPageIds.merchantCenter,
  ];
};

export const getPinedItems = (preferenceService, permissions) => {
  const preferences = preferenceService.findByNameAtUserLevel(NavRefreshL1PinnedPreferenceKey) || {};

  if (!_.isArray(preferences.Data)) {
    return getDefaultPmaxPinItems(permissions);
  }

  return preferences.Data;
};

export const processSitemap = (siteMap, preferenceService, store, activityContext, permissions): SitemapItem[] => {
  const pinnedItems = getPinedItems(preferenceService, permissions);
  const processedSiteMap = _.map(siteMap, (item) => {
    if (item.fixed) {
      return item;
    }

    const { id } = item;
    const pinned = _.contains(pinnedItems, id);
    return {
      ...item,
      pinned,
      onPinToggle: (source) => {
        let newPreference;

        if (pinned) {
          newPreference = _.without(pinnedItems, id);
        } else {
          newPreference = [...pinnedItems, id];
        }

        preferenceService.setAtUserLevel({
          Name: NavRefreshL1PinnedPreferenceKey,
          Data: newPreference,
        });

        store.setState({ pins: newPreference }); // update state to force new render
        activityContext.signal(`item ${pinned ? 'un-pined' : 'pinned'}: ${id}`, source);
      },
    };
  });
  return processedSiteMap;
};
